import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { SignalrService } from "./signalr.service";

@Injectable({providedIn: 'root'})
export class NotificationHubService {

    constructor(private SignalrService: SignalrService) {

    }

    public notificationCenterUpdateListener() : Observable<any>  {
        return this.SignalrService.listen('NotificationCenterRefresh');
    }

}